import React from 'react';
import './styles.css';
import { Button } from 'antd';
import { FrownOutlined } from '@ant-design/icons';

const ErrorMessage = ({ message }) => {

  return (
    <div className="error-message-container">
      <div className="icon-wrapper">
        <FrownOutlined />
      </div>
      <div className="text-wrapper">
        <h2>
          {
            message ? message :
              "Lo sentimos, no fue posible cargar este contenido, por favor vuelve a intentarlo."
          }
        </h2>
      </div>
      <div className="button-wrapper">
        <Button
          size="large"
          onClick={() => window.location.reload()}
        >
          Reintentar
        </Button>
      </div>
    </div>
  )
}

export default ErrorMessage;